var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.11979d6fd52134ac773ec79bc5c216a7.svg#card-carousel-arrow';
                    var viewUrl = 'sprite.11979d6fd52134ac773ec79bc5c216a7.svg#view-card-carousel-arrow';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };